const AmazonCognitoIdentity = require('amazon-cognito-identity-js');

const RegisterUser = (userdata) => {
  const userFullname = `${userdata.firstName} ${userdata.lastName}`;

  const poolData = {
    UserPoolId: process.env.VUE_APP_AWS_USER_POOL_ID, // Your user pool id here
    ClientId: process.env.VUE_APP_AWS_USER_CLIENT_ID, // Your client id here
  };

  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
  const attributeList = [];

  if (userdata.updateEmailCase) {
    attributeList.push(
      new AmazonCognitoIdentity.CognitoUserAttribute({
        Name: 'custom:updateEmailCase',
        Value: 'true',
      }),
    );
  }
  attributeList.push(
    new AmazonCognitoIdentity.CognitoUserAttribute({
      Name: 'name',
      Value: userFullname,
    }),
  );

  attributeList.push(
    new AmazonCognitoIdentity.CognitoUserAttribute({
      Name: 'email',
      Value: userdata.email,
    }),
  );

  // eslint-disable-next-line func-names
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line func-names
    userPool.signUp(userdata.email, userdata.password, attributeList, null, (
      err,
      result,
    ) => {
      if (err) {
        // eslint-disable-next-line no-console
        return reject(err);
      }
      return resolve(result);
    });
  });
};


export {
  RegisterUser as
  default,
};
